"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _Popover = _interopRequireDefault(require("@material-ui/core/Popover"));

var _pickReactKnownProp = require("pick-react-known-prop");

var useStyles = (0, _makeStyles.default)(function (theme) {
  return {
    root: {
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'flex-start'
    },
    popover: {
      pointerEvents: 'none'
    },
    paper: {
      padding: theme.spacing(1),
      backgroundColor: theme.palette.common.white
    },
    button: {
      fontWeight: 500,
      cursor: 'pointer'
    }
  };
}, {
  name: 'ProductAvailabilityFieldPreviewWithPopup'
});

function ProductAvailabilityFieldPreviewWithPopup(_ref) {
  var children = _ref.children,
      pClasses = _ref.classes,
      className = _ref.className,
      popupProps = _ref.popupProps,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "className", "popupProps"]);
  var t = (0, _useTranslate.default)();
  var classes = useStyles({
    classes: pClasses
  });

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var handlePopoverOpen = function handlePopoverOpen(event) {
    setAnchorEl(event.currentTarget);
  };

  var handlePopoverClose = function handlePopoverClose() {
    setAnchorEl(null);
  };

  var open = Boolean(anchorEl);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: classes.root
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "subtitle1",
    className: classes.button,
    onMouseEnter: handlePopoverOpen,
    onMouseLeave: handlePopoverClose
  }, t('productAvailabilityFieldPreviewWithPopup/button')), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    className: classes.popover,
    classes: {
      paper: classes.paper
    },
    open: open,
    anchorEl: anchorEl,
    onClose: handlePopoverClose,
    disableRestoreFocus: true
  }, popupProps), children));
}

process.env.NODE_ENV !== "production" ? ProductAvailabilityFieldPreviewWithPopup.propTypes = {
  children: _propTypes.default.node,
  classes: _propTypes.default.shape({
    button: _propTypes.default.string,
    paper: _propTypes.default.string,
    popover: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  popupProps: _propTypes.default.shape({})
} : void 0;
ProductAvailabilityFieldPreviewWithPopup.defaultProps = {
  children: undefined,
  classes: undefined,
  className: undefined,
  popupProps: {
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }
};
var _default = ProductAvailabilityFieldPreviewWithPopup;
exports.default = _default;